var _defs, _rect, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCardBack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    className: "card",
    face: "1B",
    height: "3.5in",
    preserveAspectRatio: "none",
    viewBox: "-120 -168 240 336",
    width: "2.5in",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "B1",
    width: 6,
    height: 6,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 0L6 3L3 6L0 3Z",
    fill: "black"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 239,
    height: 335,
    x: -119.5,
    y: -167.5,
    rx: 12,
    ry: 12,
    fill: "#3e3d3d",
    stroke: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "url(#B1)",
    width: 216,
    height: 312,
    x: -108,
    y: -156,
    rx: 12,
    ry: 12
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardBack);
export default __webpack_public_path__ + "static/media/card-back.53124d5cd6f200bb853448998d3376c7.svg";
export { ForwardRef as ReactComponent };